import { Controller } from "@hotwired/stimulus"
import { easepick, AmpPlugin } from '@easepick/bundle';

// https://easepick.com/

// Others
// https://vanilla-calendar.pro/
// https://github.com/flatpickr/flatpickr
// https://github.com/airblade/stimulus-datepicker
export default class extends Controller {
  connect() {
    this.picker = new easepick.create({
      element: this.element,
      css: [
        'https://cdn.jsdelivr.net/npm/@easepick/bundle@1.2.1/dist/index.css',
      ],
      zIndex: 10,
      plugins: [
        AmpPlugin,
      ],
      AmpPlugin: {
        dropdown: {
          months: true,
          years: true,
          minYear: 1940,
          maxYear: 2026,
        },
        resetButton: true
      },
    });

    this.picker.on("select", (e) => {
      const event = new CustomEvent("input");
      this.element.dispatchEvent(event);
    })
    this.picker.on("clear", (e) => {
      const event = new CustomEvent("input");
      this.element.dispatchEvent(event);
    })
  }

  disconnect() {
    this.picker.destroy()
  }
}
